import { OnboardingGenericTaskType } from '@tiendanube/common';
import { Country } from '@tiendanube/common/src/enums';
import ChatD2CFullBrImg from './chat-d2c-full-br.png';
import ChatD2CFullLatamImg from './chat-d2c-full-latam.png';
import ChatD2CHalfBrImg from './chat-d2c-half-br.png';
import ChatD2CHalfLatamImg from './chat-d2c-half-latam.png';
import ChatFullBrImg from './chat-full-br.png';
import ChatFullLatamImg from './chat-full-latam.png';
import ChatHalfBrImg from './chat-half-br.png';
import ChatHalfLatamImg from './chat-half-latam.png';
import PdvFullBrImg from './pdv-full-br.png';
import PdvFullLatamImg from './pdv-full-latam.png';
import PdvHalfBrImg from './pdv-half-br.png';
import PdvHalfLatamImg from './pdv-half-latam.png';

const SALE_CHANNEL_IMG = {
  chat_config: {
    [Country.BR]: {
      full: ChatFullBrImg,
      half: ChatHalfBrImg,
    },
    latam: {
      full: ChatFullLatamImg,
      half: ChatHalfLatamImg,
    },
  },
  chat_config_d2c: {
    [Country.BR]: {
      full: ChatD2CFullBrImg,
      half: ChatD2CHalfBrImg,
    },
    latam: {
      full: ChatD2CFullLatamImg,
      half: ChatD2CHalfLatamImg,
    },
  },
  pos_config: {
    [Country.BR]: {
      full: PdvFullBrImg,
      half: PdvHalfBrImg,
    },
    latam: {
      full: PdvFullLatamImg,
      half: PdvHalfLatamImg,
    },
  },
} as const;

export const getSaleChannelImg = (
  saleChannel: OnboardingGenericTaskType,
  country: Country,
  fullWidth = false,
  showNuvemChatCard = false,
): string => {
  const saleChannelMap = showNuvemChatCard
    ? SALE_CHANNEL_IMG['chat_config_d2c']
    : SALE_CHANNEL_IMG[saleChannel];
  if (!saleChannelMap) return '';

  const countryKey = saleChannelMap[country] ? country : 'latam';
  const variant = fullWidth ? 'full' : 'half';

  return saleChannelMap[countryKey][variant];
};
